export interface State {
  isLookingUpAddressBySearchTerm: boolean;
  isRetrievingAddress: boolean;
}
export enum ActionType {
  REQUEST_LOOKUP_ADDRESS_BY_SEARCH_TERM = 'validation.lookupAddressBySearchTerm',
  LOOKUP_ADDRESS_BY_SEARCH_TERM_SUCCESS = 'validation.lookupAddressBySearchTermSuccess',
  LOOKUP_ADDRESS_BY_SEARCH_TERM_FAILURE = 'validation.lookupAddressBySearchTermFailure',

  REQUEST_RETRIEVE_ADDRESS = 'validation.retrieveAddress',
  RETRIEVE_ADDRESS_SUCCESS = 'validation.retrieveAddressSuccess',
  RETRIEVE_ADDRESS_FAILURE = 'validation.retrieveAddressFailure',
}

export interface SagaConfig {
  apiBaseurl: string;
  getAuthHeader: () => Promise<string>;
  isNativeApp: boolean;
}
